export enum ClaimType {
  groupsid = "groupsid",
  primarygroupsid = "primarygroupsid",
  role = "role"
} 